import { HKGroteskFamily } from './theme'
import { InterVariableFontFamily } from './upbrandingTheme'

export const InterVariableFontFamilyTheme = {
  typography: {
    fontFamily: InterVariableFontFamily,
  }
}

export const HKGroteskFontFamilyTheme = {
  typography: {
    fontFamily: HKGroteskFamily,
  }
}
